import { Pipe, PipeTransform } from '@angular/core';
import {FilterSettingsModel} from '@syncfusion/ej2-grids';
import {DefaultTranslatedFilters} from './translations/FR/default-translated-filter';

@Pipe({
  name: 'FilterOperatorsTranslationFr'
})
export class FilterOperatorsTranslationFrPipe implements PipeTransform {

  transform(value: FilterSettingsModel): FilterSettingsModel {
    if (value != null) {
      if (value.operators == null) {
        value.operators = DefaultTranslatedFilters;
      }
    }
    return value;
  }

}
